import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";

import { isFriendlyError } from "kea-react/src/botones/exec";
/**Inicia un viaje de EAD en este dispositivo */
export async function IniciarEnDispositivo(idViajeEAD: number) {
    await resources.ViajeApp.IniciarViajeApp(idViajeEAD);
    const datosViaje = await resources.ViajeApp.ObtenerDatosViajeApp(idViajeEAD);
    const viaje = await resources.ViajeEAD.GetViaje(idViajeEAD);
    const idUsuario = await resources.User.getIdUsuario();
    if (idUsuario == null)
        throw new Error("No se puede iniciar en dispositivo sin un usuario asignado");

    const viajeState: models.ViajeAppIniciado = {
        idViajeEAD: idViajeEAD,
        datos: datosViaje,
        idUsuario: idUsuario,
        folioViajeEAD: viaje.Folio,
        model: {
            EntregasIncompletas: [],
            EntregasRealizadas: []
        }
    };

    //Almacenamos el viaje en el state:
    await globals.setState({
        viajeApp: viajeState
    });
}

/**Finaliza el viaje actual. Devuelve "ok" si se realizó correctamente la operación*/
export async function finalizarViajeApp(): Promise<"ok" | "syncError" | "sinViaje"> {
    const state = await globals.getState();
    const viajeApp = state.viajeApp;
    if (viajeApp == null)
        return "sinViaje";

    const sync = await pushViaje();
    if (!sync) return "syncError";

    await resources.ViajeApp.FinalizarViajeApp(viajeApp.idViajeEAD, viajeApp.model);
    await borrarViajeDeDispositivo();
    return "ok";
}

/**Cancela el viaje actual */
export async function cancelarViajeApp(): Promise<"ok" | "sinViaje"> {
    const state = await globals.getState();
    const viajeApp = state.viajeApp;
    if (viajeApp == null)
        return "sinViaje";
    await resources.ViajeApp.CancelarViajeApp(viajeApp.idViajeEAD);

    await borrarViajeDeDispositivo();

    return "ok";
}

/**Borra el viaje de este dispotivo */
export async function borrarViajeDeDispositivo() {
    await globals.setState({
        viajeApp: null
    });
}

/**Realiza un pull de los datos del viaje y luego un push */
export async function syncViaje(): Promise<true | "errorConexion" | "sinViaje" | "errorSubida"> {
    const ret = await pullDatosViaje();
    if (ret != "ok") return ret;
    const pushRet = await pushViaje();
    return pushRet ? true : "errorSubida";
}

/**Sincroniza el modelo del viaje App al servidor, devuelve true si si se pudo sincronizar,
 * false si no se puso sincronizar
 */
async function pushViaje(): Promise<boolean> {
    try {
        const state = await globals.getState();
        const viajeState = state.viajeApp;
        if (viajeState != null) {
            const idViajeEAD = viajeState.idViajeEAD;
            const model = viajeState.model;
            await resources.ViajeApp.SincronizarModeloViaje(idViajeEAD, model);

            /**Marcar todas las entregas finalizadas como que ya fueron contabilizadas por el servidor */
            const nuevoState: models.ViajeAppIniciado = {
                ...viajeState,
                model: {
                    ...viajeState.model,
                    EntregasRealizadas: viajeState.model.EntregasRealizadas.map(x => ({ ...x, SaldoContabilizadoServidor: x.Finalizado }))
                },
            };

            await globals.setState({ viajeApp: nuevoState });
        }

        return true;

    } catch (error) {
        if (isFriendlyError(error))
            throw error;

        console.log(error);
        return false;
    }
}

/**Intenta obtener el viaje actual del usuario, esto solo se debe de utilizar en caso de que se haya borrado el localStorage.
 * En caso de que ya existan datos en el local storage si actualiza los datos  de clientes y guias pero los datos del modelo respeta los que estan almacenados en el cliente,
 *  si no se puede conectar devuelve "errorConexion", si si se actualizadon devuelve "ok"
 * Si el usuario actual no tiene un viaje iniciado devuele "sinViaje"
 */
async function pullDatosViaje(): Promise<"errorConexion" | "ok" | "sinViaje"> {
    const state = await globals.getState();
    const viajeState = state.viajeApp;
    const datosEnCliente = viajeState != null;
    const idUsuario = await resources.User.getIdUsuario();

    if (idUsuario == null)
        throw new Error("IdUsuario es null");
    try {
        const idViajeEAD = await resources.ViajeApp.ObtenerIdViajeEADUsuario();
        if (idViajeEAD == null) return "sinViaje";


        const datosViaje = await resources.ViajeApp.ObtenerDatosViajeApp(idViajeEAD);
        if (datosEnCliente) {
            //Si ya existen datos del modelo viaje en el cliente, se respetan los que hay en el lado del cliente
            //Pero los datos de viaje si se descargan, es decir, los que no forman parte de los datos capturados por el usuario

            const nuevoState: models.ViajeAppIniciado = {
                ...viajeState!,
                datos: datosViaje,
            };

            await globals.setState({ viajeApp: nuevoState });
        } else {
            const model = await resources.ViajeApp.ObtenerModeloViaje();
            const nuevoState: models.ViajeAppIniciado = {
                idViajeEAD: idViajeEAD,
                datos: datosViaje,
                idUsuario: idUsuario,
                folioViajeEAD: datosViaje.FolioViaje,
                model: model
            };

            //Almacenamos el viaje en el state:
            await globals.setState({
                viajeApp: nuevoState
            });
        }



        return "ok";
    } catch (error) {
        if (isFriendlyError(error))
            throw error;

        console.log(error);
        return "errorConexion";
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/logic.tsx